var map = {
	"./puzzles_0": [
		531,
		531
	],
	"./puzzles_0.ts": [
		531,
		531
	],
	"./puzzles_1": [
		7353,
		7353
	],
	"./puzzles_1.ts": [
		7353,
		7353
	],
	"./puzzles_10": [
		458,
		458
	],
	"./puzzles_10.ts": [
		458,
		458
	],
	"./puzzles_11": [
		3502,
		3502
	],
	"./puzzles_11.ts": [
		3502,
		3502
	],
	"./puzzles_12": [
		6882,
		6882
	],
	"./puzzles_12.ts": [
		6882,
		6882
	],
	"./puzzles_13": [
		946,
		946
	],
	"./puzzles_13.ts": [
		946,
		946
	],
	"./puzzles_14": [
		3336,
		3336
	],
	"./puzzles_14.ts": [
		3336,
		3336
	],
	"./puzzles_15": [
		6947,
		6947
	],
	"./puzzles_15.ts": [
		6947,
		6947
	],
	"./puzzles_16": [
		3201,
		3201
	],
	"./puzzles_16.ts": [
		3201,
		3201
	],
	"./puzzles_17": [
		294,
		294
	],
	"./puzzles_17.ts": [
		294,
		294
	],
	"./puzzles_18": [
		5482,
		5482
	],
	"./puzzles_18.ts": [
		5482,
		5482
	],
	"./puzzles_19": [
		4914,
		4914
	],
	"./puzzles_19.ts": [
		4914,
		4914
	],
	"./puzzles_2": [
		4800,
		4800
	],
	"./puzzles_2.ts": [
		4800,
		4800
	],
	"./puzzles_20": [
		1325,
		1325
	],
	"./puzzles_20.ts": [
		1325,
		1325
	],
	"./puzzles_21": [
		3093,
		3093
	],
	"./puzzles_21.ts": [
		3093,
		3093
	],
	"./puzzles_22": [
		691,
		691
	],
	"./puzzles_22.ts": [
		691,
		691
	],
	"./puzzles_23": [
		3046,
		3046
	],
	"./puzzles_23.ts": [
		3046,
		3046
	],
	"./puzzles_24": [
		6506,
		6506
	],
	"./puzzles_24.ts": [
		6506,
		6506
	],
	"./puzzles_25": [
		1577,
		1577
	],
	"./puzzles_25.ts": [
		1577,
		1577
	],
	"./puzzles_26": [
		8126,
		8126
	],
	"./puzzles_26.ts": [
		8126,
		8126
	],
	"./puzzles_27": [
		985,
		985
	],
	"./puzzles_27.ts": [
		985,
		985
	],
	"./puzzles_28": [
		4320,
		4320
	],
	"./puzzles_28.ts": [
		4320,
		4320
	],
	"./puzzles_29": [
		8999,
		8999
	],
	"./puzzles_29.ts": [
		8999,
		8999
	],
	"./puzzles_3": [
		1298,
		1298
	],
	"./puzzles_3.ts": [
		1298,
		1298
	],
	"./puzzles_30": [
		8595,
		8595
	],
	"./puzzles_30.ts": [
		8595,
		8595
	],
	"./puzzles_31": [
		6541,
		6541
	],
	"./puzzles_31.ts": [
		6541,
		6541
	],
	"./puzzles_32": [
		6238,
		6238
	],
	"./puzzles_32.ts": [
		6238,
		6238
	],
	"./puzzles_33": [
		8987,
		8987
	],
	"./puzzles_33.ts": [
		8987,
		8987
	],
	"./puzzles_34": [
		9812,
		9812
	],
	"./puzzles_34.ts": [
		9812,
		9812
	],
	"./puzzles_4": [
		9211,
		9211
	],
	"./puzzles_4.ts": [
		9211,
		9211
	],
	"./puzzles_5": [
		1137,
		1137
	],
	"./puzzles_5.ts": [
		1137,
		1137
	],
	"./puzzles_6": [
		3559,
		3559
	],
	"./puzzles_6.ts": [
		3559,
		3559
	],
	"./puzzles_7": [
		9098,
		9098
	],
	"./puzzles_7.ts": [
		9098,
		9098
	],
	"./puzzles_8": [
		1522,
		1522
	],
	"./puzzles_8.ts": [
		1522,
		1522
	],
	"./puzzles_9": [
		6196,
		6196
	],
	"./puzzles_9.ts": [
		6196,
		6196
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6985;
module.exports = webpackAsyncContext;